import {
  CONDITION_ICON_COMPONENT_BY_ID,
  DEFAULT_CONDITION_ICON_COMPONENT,
} from './config/conditionIcons.config';

export default function ConditionIcons({ conditionId, size, style }) {
  const ConditionIconComponent =
    CONDITION_ICON_COMPONENT_BY_ID[Number.parseInt(conditionId, 10)] ??
    DEFAULT_CONDITION_ICON_COMPONENT;

  return <ConditionIconComponent size={size} style={style} />;
}
